import { createAction } from '@reduxjs/toolkit';
import {
  BroadcastAllowedPayload,
  BroadcastAllowedUser,
  ChangeRolePayload,
  PermissionChangePayload,
  RoleChangedPayload,
  UserId,
  UserIdPayload,
} from 'features/users/types';
import {
  BulkAllowBroadcastPayload,
  BulkDisallowBroadcastPayload,
  BulkEditWhiteboardPayload,
  BulkPresentContentPayload,
  BulkScreensharePayload,
  ManageBroadcastPayload,
} from 'features/permissions/types';
import { SignalingEventPayload } from 'services/signaling';

export const allowBroadcast = createAction<ManageBroadcastPayload>('permissions/allowBroadcast');
export const disallowBroadcast = createAction<UserId>('permissions/disallowBroadcast');
export const bulkAllowBroadcast = createAction<BulkAllowBroadcastPayload>(
  'permissions/bulkAllowBroadcast'
);
export const bulkDisallowBroadcast = createAction<BulkDisallowBroadcastPayload>(
  'permissions/bulkDisallowBroadcast'
);
export const signalingBroadcastAllowed = createAction<
  SignalingEventPayload<{ users: BroadcastAllowedUser[] }>
>('signaling/permissions/broadcastAllowed');
export const signalingBroadcastDisallowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/broadcastDisallowed');

export const allowScreenshare = createAction<UserId>('permissions/allowScreenshare');
export const disallowScreenshare = createAction<UserId>('permissions/disallowScreenshare');
export const bulkAllowScreenshare = createAction<BulkScreensharePayload>(
  'permissions/bulkAllowScreenshare'
);
export const bulkDisallowScreenshare = createAction<BulkScreensharePayload>(
  'permissions/bulkDisallowScreenshare'
);
export const signalingScreenshareAllowed = createAction<SignalingEventPayload<{ users: UserId[] }>>(
  'signaling/permissions/screenshareAllowed'
);
export const signalingScreenshareDisallowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/screenshareDisallowed');

export const changeRoleRequest = createAction<ChangeRolePayload>('permissions/changeRoleRequest');
export const signalingRoleChanged = createAction<RoleChangedPayload>(
  'signaling/permissions/roleChanged'
);

export const broadcastPermissionGranted = createAction<BroadcastAllowedPayload>(
  'permissions/broadcastPermissionGranted'
);
export const broadcastPermissionRevoked = createAction<PermissionChangePayload>(
  'permissions/broadcastPermissionRevoked'
);

export const whiteboardPermissionGranted = createAction<PermissionChangePayload>(
  'permissions/whiteboardPermissionGranted'
);

export const whiteboardPermissionRevoked = createAction<PermissionChangePayload>(
  'permissions/whiteboardPermissionRevoked'
);

export const managePrivateWhiteboardPermissionRevoked = createAction<PermissionChangePayload>(
  'permissions/whiteboardPermissionRevoked'
);

export const allowEditWhiteboard = createAction<UserId>('permissions/allowEditWhiteboard');
export const disallowEditWhiteboard = createAction<UserId>('permissions/disallowEditWhiteboard');
export const bulkAllowEditWhiteboard = createAction<BulkEditWhiteboardPayload>(
  'permissions/bulkAllowEditWhiteboard'
);
export const bulkDisallowEditWhiteboard = createAction<BulkEditWhiteboardPayload>(
  'permissions/bulkDisallowEditWhiteboard'
);

export const signalingEditWhiteboardAllowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/editWhiteboardAllowed');
export const signalingEditWhiteboardDisallowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/editWhiteboardDisallowed');

export const allowPresentContent = createAction<UserId>('permissions/allowPresentContent');
export const disallowPresentContent = createAction<UserId>('permissions/disallowPresentContent');
export const bulkAllowPresentContent = createAction<BulkPresentContentPayload>(
  'permissions/bulkAllowPresentContent'
);
export const bulkDisallowPresentContent = createAction<BulkPresentContentPayload>(
  'permissions/bulkDisallowPresentContent'
);

export const signalingPresentContentAllowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/presentContentAllowed');
export const signalingPresentContentDisallowed = createAction<
  SignalingEventPayload<{ users: UserId[] }>
>('signaling/permissions/presentContentDisallowed');

export const dynamicBroadcastPermissionsReset = createAction<UserIdPayload>(
  'permissions/dynamicBroadcastPermissionsReset'
);
